<template>
  <v-row no-gutters>
    <div class="col-12 col-md-6">
      <Input
        class="mx-4"
        :data="{
          text: this.text.zipcode,
          name: 'zipcode',
          onblur: true,
          onkeyup: true,
          rules: this.zipcodeRules,
          value: this.zipcode
        }"
        @childToParent="inputFormZipcode"
      />
    </div>
    <div class="col-12 col-md-6">
      <Input
        class="mx-4"
        :data="{
          text: this.text.city,
          name: 'city',
          onblur: true,
          rules: this.cityRules,
          value: this.cityInternal
        }"
        :value="cityInternal"
        :cityInputIsDisabled="cityInputIsDisabledInternal"
      />
    </div>
  </v-row>
</template>
<script>
import $axios from '../settings/axios.js';
import Input from '@/components/fragments/input.vue';
import localizationTexts from '@/localization/texts.json';
import Vue from 'vue';

export default Vue.extend({
  name: 'ZipcodeCityLookup',
  props: {
    user: Object,
    zipcode: String,
    city: String,
    cityInputIsDisabled: Boolean,
    rules: String
  },
  data() {
    return {
      userInternal: this.user,
      cityInputIsDisabledInternal: this.cityInputIsDisabled,
      cityInternal: this.city,
      text: {
        zipcode: '',
        city: ''
      },
      zipcodeRules: [
        v => !!v || localizationTexts[this.userInternal.config.language].validation.missing.zipcode,
        v => RegExp(this.rules).test(v) || localizationTexts[this.userInternal.config.language].validation.specific.zipcodeValid
      ],
      cityRules: [v => !!v || localizationTexts[this.userInternal.config.language].validation.missing.city]
    };
  },
  mounted() {
    this.text.zipcode = localizationTexts[this.userInternal.config.language].pageContact.zipCode;
    this.text.city = localizationTexts[this.userInternal.config.language].pageContact.city;
  },
  components: {
    Input
  },
  methods: {
    inputFormZipcode(newZipcode) {
      const regex = new RegExp(this.userInternal.config.prop.zip);
      if (!regex.test(newZipcode) || newZipcode == this.zipcode) return;

      this.$emit('zipcodeChanged', newZipcode);
      const payload = {
        endpoint: this.userInternal.config.parameters.api + '/location/city',
        params: {
          traceid: this.userInternal.guid,
          culture: this.userInternal.config.parameters.parameters.culture,
          zipcode: newZipcode
        }
      };
      $axios
        .post(payload.endpoint, payload.params)
        .then(response => {
          this.cityInternal = '';
          this.cityInputIsDisabledInternal = response.data.cityname !== null;
          if (response.data.cityname !== null) {
            this.cityInternal = response.data.cityname;
            this.$emit('cityChanged', response.data.cityname);
          }
        })
        .catch(() => {
          this.cityInputIsDisabledInternal = false;
        });
    },
    inputFormCity(newCity) {
      this.$emit('cityChanged', newCity);
    }
  },
  watch: {
    zipcode: {
      handler(newVal) {
        const regex = new RegExp(this.userInternal.config.prop.zip);
        const isValidZipcode = regex.test(newVal);
        if (isValidZipcode) {
          this.inputFormZipcode(newVal);
        }
      },
      deep: true,
      immediate: true
    }
  }
});
</script>
<style scoped lang="scss"></style>

<i18n src="../localization/texts.json"></i18n>
